export default "__VITE_ASSET__DDBACF$7__"